webpackJsonp([125],{

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditInternEditForm_vue__ = __webpack_require__(2520);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ceffca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditInternEditForm_vue__ = __webpack_require__(3210);
function injectStyle (ssrContext) {
  __webpack_require__(3200)
  __webpack_require__(3202)
  this["$style"] = __webpack_require__(3204)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52ceffca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditInternEditForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52ceffca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditInternEditForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(22);


/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(12);
var LIBRARY = __webpack_require__(104);
var wksExt = __webpack_require__(1350);
var defineProperty = __webpack_require__(54).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(144)('meta');
var isObject = __webpack_require__(55);
var has = __webpack_require__(75);
var setDesc = __webpack_require__(54).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(76)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(244);
var hiddenKeys = __webpack_require__(148).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(79);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1365);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1366);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 1365:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1368), __esModule: true };

/***/ }),

/***/ 1366:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1369), __esModule: true };

/***/ }),

/***/ 1367:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(235);
var createDesc = __webpack_require__(103);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var has = __webpack_require__(75);
var IE8_DOM_DEFINE = __webpack_require__(243);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(40) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(143);
__webpack_require__(234);
module.exports = __webpack_require__(1350).f('iterator');


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1370);
__webpack_require__(241);
__webpack_require__(1373);
__webpack_require__(1374);
module.exports = __webpack_require__(12).Symbol;


/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(40);
var $export = __webpack_require__(28);
var redefine = __webpack_require__(245);
var META = __webpack_require__(1353).KEY;
var $fails = __webpack_require__(76);
var shared = __webpack_require__(147);
var setToStringTag = __webpack_require__(105);
var uid = __webpack_require__(144);
var wks = __webpack_require__(22);
var wksExt = __webpack_require__(1350);
var wksDefine = __webpack_require__(1351);
var enumKeys = __webpack_require__(1371);
var isArray = __webpack_require__(1356);
var anObject = __webpack_require__(41);
var isObject = __webpack_require__(55);
var toObject = __webpack_require__(78);
var toIObject = __webpack_require__(100);
var toPrimitive = __webpack_require__(236);
var createDesc = __webpack_require__(103);
var _create = __webpack_require__(240);
var gOPNExt = __webpack_require__(1372);
var $GOPD = __webpack_require__(1367);
var $GOPS = __webpack_require__(237);
var $DP = __webpack_require__(54);
var $keys = __webpack_require__(101);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1354).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(235).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(104)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(101);
var gOPS = __webpack_require__(237);
var pIE = __webpack_require__(235);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100);
var gOPN = __webpack_require__(1354).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('asyncIterator');


/***/ }),

/***/ 1374:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1351)('observable');


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 1865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auditInternPermissionMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var baseExportHeader = [{ key: 'id', text: '账号ID' }, { key: 'name', text: '账号' }, { key: 'realname', text: '姓名' }, { key: 'employment_type', text: '人员性质' }, { key: 'office_location', text: '办公地点' }, { key: 'status', text: '状态' }, { key: 'phone', text: '手机号' }, { key: 'mail_address', text: '个人邮箱' }, { key: 'school', text: '目前所在院校' }, { key: 'major', text: '专业' }, { key: 'education_level', text: '学历' }, { key: 'grade_level', text: '当前学年段' }, { key: 'student_card_photos', text: '学生证照片' }, { key: 'contract_start_date', text: '合同开始时间' }, { key: 'contract_end_date', text: '合同结束时间' }, { key: 'remark', text: '备注' }, { key: 'participant_customers', text: '累计参与客户(系统自动维护,不可修改)' }, { key: 'participant_projects', text: '累计参与项目(系统自动维护,不可修改)' }];

// 权限控制方法
var auditInternPermissionMixin = {
  methods: {
    /**
     * 判断是否允许查看实习生列表
     * @returns {boolean}
     */
    allowViewInternTable: function allowViewInternTable() {
      return filter.hasPermission(40001);
    },

    /**
     * 判断是否允许编辑/查看基础资料
     * @returns {boolean}
     */
    allowViewEditBase: function allowViewEditBase() {
      return filter.hasPermission(40002);
    },

    /**
     * 判断是否允许编辑/查看隐私信息
     * @returns {boolean}
     */
    allowViewEditPrivate: function allowViewEditPrivate() {
      return filter.hasPermission(40003);
    },

    /**
     * 判断是否允许编辑/查看资源控制信息
     * @returns {boolean}
     */
    allowViewEditResource: function allowViewEditResource() {
      return filter.hasPermission(40004);
    },

    /**
     * 判断是否允许编辑/查看分配用户资源
     * @returns {boolean}
     */
    allowViewEditUserResource: function allowViewEditUserResource() {
      return filter.hasPermission(40005);
    },

    /**
     * 判断是否允许添加实习生账号
     * @returns {boolean}
     */
    allowCreateIntern: function allowCreateIntern() {
      return filter.hasPermission(40006);
    },

    /**
     * 判断是否允许导出实习生隐私信息
     * @returns {boolean}
     */
    allowExportPrivateData: function allowExportPrivateData() {
      return filter.hasPermission(40007);
    }
  },
  computed: {
    /**
     * 根据权限自动选择默认标签页
     * @returns {string}
     */
    getActiveTab: function getActiveTab() {
      if (this.allowViewEditBase()) {
        return 'baseInfo';
      } else if (this.allowViewEditPrivate()) {
        return 'privateInfo';
      } else if (this.allowViewEditResource()) {
        return 'resourceInfo';
      } else if (this.allowViewEditUserResource()) {
        return 'userResourceInfo';
      } else {
        return '';
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    var _this = this;

    return {
      tableColumns: [{ prop: 'id', label: '账号ID', minWidth: '90' }, { prop: 'realname', label: '姓名', minWidth: '100' }, { prop: 'name', label: '账号', minWidth: '120' }, { prop: 'phone', label: '手机号', minWidth: '120' }, { prop: 'employment_type', label: '人员性质', minWidth: '80', formatter: function formatter(row) {
          return _.get(_this.employmentTypeMap, row.employment_type, '-');
        } }, { prop: 'participant_customers', label: '累计参与客户', width: '200' }, { prop: 'status', label: '用户状态', minWidth: '100', formatter: function formatter(row) {
          return _.get(_this.statusMap, row.status, '-');
        } }, { prop: 'total_work_days', label: '累计出勤天数', minWidth: '100' }],
      exportBaseHeader: baseExportHeader,
      exportFullHeader: [].concat(baseExportHeader, [{ key: 'assigned_customers', text: '客户资源' }, { key: 'ui_roles', text: 'UI角色' }, { key: 'api_roles', text: 'API角色' }, { key: 'id_number', text: '身份证号' }, { key: 'id_card_front_photo', text: '身份证正面照片' }, { key: 'id_card_back_photo', text: '身份证反面照片' }, { key: 'bank_name', text: '银行名称' }, { key: 'bank_branch_name', text: '支行信息' }, { key: 'bank_card_number', text: '银行卡号' }, { key: 'bank_card_photo', text: '银行卡照片' }])
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    employmentTypeMap: function employmentTypeMap(state) {
      return state.auditIntern.employmentTypeMap;
    },
    educationLevelMap: function educationLevelMap(state) {
      return state.auditIntern.educationLevelMap;
    },
    officeLocationMap: function officeLocationMap(state) {
      return state.auditIntern.officeLocationMap;
    },
    gradeLevelMap: function gradeLevelMap(state) {
      return state.auditIntern.gradeLevelMap;
    },
    statusMap: function statusMap(state) {
      return state.auditIntern.statusMap;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, auditInternPermissionMixin.methods)
});

/***/ }),

/***/ 1866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pageType: {
      type: String,
      default: 'create'
    },
    internId: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      studentCardPhotoList: []
    };
  },

  watch: {
    'formData.student_card_photos': {
      handler: function handler(newVal) {
        // 只在 studentCardPhotoList 为空时初始化，避免后续操作导致闪烁
        if (this.studentCardPhotoList.length === 0 && newVal && newVal.length > 0) {
          this.studentCardPhotoList = newVal.map(function (url) {
            return { url: url, status: 'ready' };
          });
        }
      },

      immediate: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    formData: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    },
    contractDateRange: {
      get: function get() {
        return [this.formData.contract_start_date || '', this.formData.contract_end_date || ''];
      },
      set: function set(val) {
        if (val && val.length === 2) {
          this.$set(this.formData, 'contract_start_date', val[0]);
          this.$set(this.formData, 'contract_end_date', val[1]);
        } else {
          this.$set(this.formData, 'contract_start_date', '');
          this.$set(this.formData, 'contract_end_date', '');
        }
      }
    }
  }, Vuex.mapState({
    employmentTypeMap: function employmentTypeMap(state) {
      return state.auditIntern.employmentTypeMap;
    },
    educationLevelMap: function educationLevelMap(state) {
      return state.auditIntern.educationLevelMap;
    },
    officeLocationMap: function officeLocationMap(state) {
      return state.auditIntern.officeLocationMap;
    },
    gradeLevelMap: function gradeLevelMap(state) {
      return state.auditIntern.gradeLevelMap;
    },
    statusMap: function statusMap(state) {
      return state.auditIntern.statusMap;
    }
  })),
  methods: {
    reset: function reset() {
      // 清空表单数据
      this.studentCardPhotoList = [];
    },
    handleRemove: function handleRemove(file, fileList, field) {
      if (field === 'student_card_photos') {
        // 同时更新 photoList 和 formData
        this.studentCardPhotoList = fileList.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, { status: 'ready' });
        });
        this.formData[field] = fileList.map(function (item) {
          return item.response || item.url;
        });
      }
    },
    onChangeFile: function onChangeFile(file, fileList, field) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isImage, isLt10M, fieldMap, apiField, result, lastFile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isImage = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
                isLt10M = file.raw.size / 1024 / 1024 < 10;

                if (isImage) {
                  _context.next = 6;
                  break;
                }

                _this.$message.error('请上传jpg/png图片!');
                _this.removeInvalidFile(file, fileList, field);
                return _context.abrupt('return', false);

              case 6:
                if (isLt10M) {
                  _context.next = 10;
                  break;
                }

                _this.$message.error('大小不能超过10MB!');
                _this.removeInvalidFile(file, fileList, field);
                return _context.abrupt('return', false);

              case 10:
                fieldMap = {
                  'student_card_photos': 'intern_studentcard'
                };
                apiField = _.get(fieldMap, field, field);
                _context.prev = 12;
                _context.next = 15;
                return _this.uploadFile(file.raw, apiField);

              case 15:
                result = _context.sent;

                if (result.success) {
                  // 上传成功，更新最后一个文件的 response
                  lastFile = fileList[fileList.length - 1];

                  lastFile.response = result.url;
                  // 同时更新 photoList 和 formData，设置status为success隐藏绿色对勾
                  _this.studentCardPhotoList = fileList.map(function (item) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, { status: 'ready' });
                  });
                  _this.formData[field] = fileList.map(function (item) {
                    return item.response || item.url;
                  });
                } else {
                  _this.$message.error(result.error || '上传失败');
                  _this.removeInvalidFile(file, fileList, field);
                }
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](12);

                _this.$message.error(_context.t0.message || '上传失败');
                _this.removeInvalidFile(file, fileList, field);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 19]]);
      }))();
    },
    removeInvalidFile: function removeInvalidFile(file, fileList, field) {
      var index = fileList.indexOf(file);
      if (index > -1) {
        fileList.splice(index, 1);
        if (field === 'student_card_photos') {
          // 同时更新 photoList 和 formData
          this.studentCardPhotoList = fileList;
          this.formData[field] = fileList.map(function (item) {
            return item.response || item.url;
          });
        }
      }
    },
    getExtByBlob: function getExtByBlob(blob) {
      var fileName = blob.name;
      return fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    },
    uploadFile: function uploadFile(file, field) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var blob, params, res, uploadUrl, contentType, fileUrl, uploadRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                blob = file.raw || file;
                // 获取签名URL

                params = {
                  intern_id: _this2.internId,
                  ext: _this2.getExtByBlob(blob),
                  content_type: blob.type,
                  oss_tpl: field
                };
                _context2.next = 5;
                return request.common('getOssSignedUrlApi', params);

              case 5:
                res = _context2.sent;

                if (!(res.status === 200)) {
                  _context2.next = 18;
                  break;
                }

                uploadUrl = res.data.signedUrl;
                contentType = res.data.content_type;
                fileUrl = res.data.url;
                // 上传文件到签名URL

                _context2.next = 12;
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': contentType }),
                  body: blob
                });

              case 12:
                uploadRes = _context2.sent;

                if (uploadRes.ok) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt('return', { success: false, error: '\u4E0A\u4F20\u5931\u8D25: ' + uploadRes.status + ' ' + uploadRes.statusText });

              case 17:
                return _context2.abrupt('return', { success: true, url: fileUrl });

              case 18:
                return _context2.abrupt('return', { success: false, error: '获取上传地址失败' });

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', { success: false, error: _context2.t0.message || '上传失败' });

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 21]]);
      }))();
    }
  }
});

/***/ }),

/***/ 1867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    internId: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      bankCardPhotoList: []
    };
  },

  computed: {
    formData: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    'formData.bank_card_photo': {
      handler: function handler(newVal) {
        // 只在 bankCardPhotoList 为空时初始化，避免后续操作导致闪烁
        if (this.bankCardPhotoList.length === 0 && newVal && newVal.length > 0) {
          this.bankCardPhotoList = newVal.map(function (url) {
            return { url: url, status: 'ready' };
          });
        }
      },

      immediate: true
    }
  },
  methods: {
    reset: function reset() {
      // 清空表单数据
      this.formData.id_number = '';
      this.formData.id_card_front_photo = '';
      this.formData.id_card_back_photo = '';
      this.formData.bank_name = '';
      this.formData.bank_branch_name = '';
      this.formData.bank_card_number = '';
      this.formData.bank_card_photo = [];
      this.bankCardPhotoList = [];
    },
    handleRemove: function handleRemove(file, fileList, field) {
      if (field === 'bank_card_photo') {
        // 同时更新 photoList 和 formData
        this.bankCardPhotoList = fileList.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, { status: 'ready' });
        });
        this.formData[field] = fileList.map(function (item) {
          return item.response || item.url;
        });
      } else if (['id_card_front_photo', 'id_card_back_photo'].includes(field)) {
        this.formData[field] = '';
      }
    },
    onChangeFile: function onChangeFile(file, fileList, field) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isImage, isLt10M, fieldMap, apiField, result, lastFile;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isImage = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
                isLt10M = file.raw.size / 1024 / 1024 < 10;

                if (isImage) {
                  _context.next = 6;
                  break;
                }

                _this.$message.error('请上传jpg/png图片!');
                _this.removeInvalidFile(file, fileList, field);
                return _context.abrupt('return', false);

              case 6:
                if (isLt10M) {
                  _context.next = 10;
                  break;
                }

                _this.$message.error('大小不能超过10MB!');
                _this.removeInvalidFile(file, fileList, field);
                return _context.abrupt('return', false);

              case 10:
                fieldMap = {
                  'id_card_front_photo': 'intern_idcard_front',
                  'id_card_back_photo': 'intern_idcard_back',
                  'bank_card_photo': 'intern_bankcard'
                };
                apiField = _.get(fieldMap, field, field);
                _context.prev = 12;
                _context.next = 15;
                return _this.uploadFile(file.raw, apiField);

              case 15:
                result = _context.sent;

                if (result.success) {
                  if (field === 'bank_card_photo') {
                    // 上传成功，更新最后一个文件的 response
                    lastFile = fileList[fileList.length - 1];

                    lastFile.response = result.url;
                    _this.bankCardPhotoList = fileList.map(function (item) {
                      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, item, { status: 'ready' });
                    });
                    _this.formData[field] = fileList.map(function (item) {
                      return item.response || item.url;
                    });
                  } else if (['id_card_front_photo', 'id_card_back_photo'].includes(field)) {
                    _this.formData[field] = result.url;
                  }
                } else {
                  _this.$message.error(result.error || '上传失败');
                  _this.removeInvalidFile(file, fileList, field);
                }
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](12);

                _this.$message.error(_context.t0.message || '上传失败');
                _this.removeInvalidFile(file, fileList, field);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 19]]);
      }))();
    },
    removeInvalidFile: function removeInvalidFile(file, fileList, field) {
      var index = fileList.indexOf(file);
      if (index > -1) {
        fileList.splice(index, 1);
        if (field === 'bank_card_photo') {
          // 同时更新 photoList 和 formData
          this.bankCardPhotoList = fileList;
          this.formData[field] = fileList.map(function (item) {
            return item.response || item.url;
          });
        }
      }
    },
    getExtByBlob: function getExtByBlob(blob) {
      var fileName = blob.name || 'file.jpg';
      var ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return ext || '.jpg';
    },
    uploadFile: function uploadFile(file, field) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var blob, params, res, uploadUrl, contentType, fileUrl, uploadRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                blob = file.raw || file;
                // 获取签名URL

                params = {
                  intern_id: _this2.internId,
                  ext: _this2.getExtByBlob(blob),
                  content_type: blob.type,
                  oss_tpl: field
                };
                _context2.next = 5;
                return request.common('getOssSignedUrlApi', params);

              case 5:
                res = _context2.sent;

                if (!(res.status === 200)) {
                  _context2.next = 18;
                  break;
                }

                uploadUrl = res.data.signedUrl;
                contentType = res.data.content_type;
                fileUrl = res.data.url;
                // 上传文件到签名URL

                _context2.next = 12;
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': contentType }),
                  body: blob
                });

              case 12:
                uploadRes = _context2.sent;

                if (uploadRes.ok) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt('return', { success: false, error: '\u4E0A\u4F20\u5931\u8D25: ' + uploadRes.status + ' ' + uploadRes.statusText });

              case 17:
                return _context2.abrupt('return', { success: true, url: fileUrl });

              case 18:
                return _context2.abrupt('return', { success: false, error: '获取上传地址失败' });

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2['catch'](0);
                return _context2.abrupt('return', { success: false, error: _context2.t0.message || '上传失败' });

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 21]]);
      }))();
    }
  }
});

/***/ }),

/***/ 1868:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform_user_province_rules_js__ = __webpack_require__(2136);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    userid: {
      type: [Number, String],
      default: null
    },
    callbackAfterUpdate: {
      type: Function,
      default: function _default() {}
    }
  },
  components: {},
  data: function data() {
    return {
      formRules: __WEBPACK_IMPORTED_MODULE_3__platform_user_province_rules_js__["a" /* formRules */],
      provinceId: null,
      cityId: null,
      provinceName: null,
      cityName: null,
      rule: null,
      form: {
        id: this.userid,
        name: null,
        provinceid: null,
        provinces: []
      },
      options: {
        rules: [{ label: '全国', value: -1 }, { label: '按省市分配', value: 2 }, { label: '未分配', value: 0 }],
        province: []
      }
    };
  },

  computed: {},
  watch: {
    userid: function userid(newVal) {
      if (newVal > 0) {
        this.setForm(newVal);
      }
    }
  },
  created: function created() {
    if (this.userid > 0) {
      this.setForm(this.userid);
    }
  },
  mounted: function mounted() {},

  methods: {
    setForm: function setForm(id) {
      var _this = this;

      request.all.common([request('getProvinceList'), request('getPlatformUsersProvince', id)]).then(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            province = _ref2[0],
            form = _ref2[1];

        (function (_ref3) {
          var data = _ref3.data;

          for (var i = 0; i < data.length; i++) {
            _this.options.province.push({ value: data[i].id, label: data[i].name, type: data[i].type, children: [] });
          }
        })(province);
        (function (_ref4) {
          var data = _ref4.data;

          filter.setLoop(_this.form, data);
          if (data.provinceid === '') {
            _this.rule = 0;
          } else if (parseInt(data.provinceid) === -1) {
            _this.rule = -1;
          } else {
            _this.rule = 2;
          }
          _this.form.provinces = data.strProvinceIds;
        })(form);
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this2.form.provinceid = _this2.rule;
          if (_this2.rule === 0) {
            _this2.form.provinceid = '';
          }
          if (_this2.rule === 2 && _this2.form.provinces.length <= 0) {
            _this2.form.provinceid = '';
          }

          _this2.update(_this2.id);
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    update: function update(id) {
      var _this3 = this;

      request.common('updatePlatformUserProvince', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.form)).then(function (res) {
        _this3.callbackAfterUpdate();
      });
    },
    onChangeProvince: function onChangeProvince(value) {
      var _this4 = this;

      this.cityId = '';
      this.cityName = '';

      var _loop = function _loop(i) {
        if (_this4.options.province[i].value === value) {
          _this4.provinceName = _this4.options.province[i].label;
          if (_this4.options.province[i].children.length > 0) {
            return {
              v: false
            };
          } else {
            request.common('getCityList', value).then(function (_ref5) {
              var data = _ref5.data;

              for (var n = 0; n < data.length; n++) {
                _this4.options.province[i].children.push({ value: data[n].id, label: data[n].name, type: data[n].type });
              }
              return true;
            });
          }
        }
      };

      for (var i = 0; i < this.options.province.length; i++) {
        var _ret = _loop(i);

        if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
      }
    },
    onChangeCity: function onChangeCity(value) {
      this.cityId = value;
      for (var i = 0; i < this.options.province.length; i++) {
        if (this.options.province[i].value === this.provinceId) {
          for (var n = 0; n < this.options.province[i].children.length; n++) {
            if (this.options.province[i].children[n].value === value) {
              this.cityName = this.options.province[i].children[n].label;
            }
          }
        }
      }
    },
    onAddResource: function onAddResource() {
      if (!this.provinceId) {
        return false;
      }
      this.getResourceName();
    },
    onDeleteResource: function onDeleteResource(index) {
      this.form.provinces.splice(index, 1);
    },
    getResourceName: function getResourceName() {
      if (this.cityId) {
        for (var i = 0; i < this.form.provinces.length; i++) {
          if (parseInt(this.form.provinces[i].value) === parseInt(this.cityId)) {
            this.$confirm('已添加' + this.provinceName + '/' + this.cityName + '，请勿重复添加');
            return false;
          }
          if (parseInt(this.form.provinces[i].value) === parseInt(this.provinceId)) {
            this.$confirm('已添加省' + this.provinceName + ',添加市失败' + this.cityName);
            return false;
          }
        }

        this.form.provinces.push({
          label: this.provinceName + '/' + this.cityName,
          value: this.cityId,
          provinceId: this.provinceId,
          type: 1
        });
      } else {
        var message = '';
        for (var n = 0; n < this.form.provinces.length; n++) {
          if (parseInt(this.form.provinces[n].provinceId) === parseInt(this.provinceId)) {
            if (parseInt(this.form.provinces[n].type) === 0) {
              this.$confirm('已添加' + this.provinceName + '，请勿重复添加');
              return false;
            } else {
              message += this.form.provinces[n].label + ',';
              this.form.provinces.splice(n, 1);
            }
          }
        }
        this.form.provinces.push({
          label: this.provinceName,
          value: this.provinceId,
          provinceId: this.provinceId,
          type: 0
        });
        if (message) {
          this.$confirm('由于添加' + this.provinceName + ',删除' + message);
        }
      }
      this.provinceId = null;
      this.cityId = null;
      this.provinceName = null;
      this.cityName = null;
    }
  }
});

/***/ }),

/***/ 2122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return privateFormRules; });
var baseFormRules = {
  // 账号名称
  name: [{ required: true, message: '请输入账号名称', trigger: 'blur' }],
  // 姓名
  realname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  // 类型
  employment_type: [{ required: true, message: '请选择人员性质', trigger: 'change' }],
  office_location: [{ required: true, message: '请选择办公地点', trigger: 'change' }],
  // 手机号
  phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }],
  // 合同时间 - 验证开始日期
  contract_start_date: [{ required: true, message: '请选择合同时间', trigger: 'change' }]
};

var privateFormRules = {
  id_number: [{ required: true, message: '请输入身份证号码', trigger: 'blur' }]
};

/***/ }),

/***/ 2123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseInfoForm_vue__ = __webpack_require__(1866);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31357340_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseInfoForm_vue__ = __webpack_require__(2124);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseInfoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31357340_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseInfoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"账号名称","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"系统登录账号名称"},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"姓名","prop":"realname"}},[_c('el-input',{attrs:{"placeholder":"请输入姓名"},model:{value:(_vm.formData.realname),callback:function ($$v) {_vm.$set(_vm.formData, "realname", $$v)},expression:"formData.realname"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"密码","prop":"password"}},[(_vm.pageType === 'create')?[_c('span',[_vm._v("默认密码为 "+_vm._s(_vm.formData.password))])]:_c('el-input',{attrs:{"placeholder":"无需修改密码时请留空"},model:{value:(_vm.formData.password),callback:function ($$v) {_vm.$set(_vm.formData, "password", $$v)},expression:"formData.password"}})],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"人员性质","prop":"employment_type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择人员性质"},model:{value:(_vm.formData.employment_type),callback:function ($$v) {_vm.$set(_vm.formData, "employment_type", $$v)},expression:"formData.employment_type"}},_vm._l((_vm.employmentTypeMap),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":Number(value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"账号状态","prop":"status"}},[(_vm.pageType === 'create')?[_c('span',[_vm._v(_vm._s(_vm.statusMap[_vm.formData.status] || ''))])]:_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择账号状态"},model:{value:(_vm.formData.status),callback:function ($$v) {_vm.$set(_vm.formData, "status", $$v)},expression:"formData.status"}},_vm._l((_vm.statusMap),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":Number(value)}})}),1)],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号","prop":"phone"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号"},model:{value:(_vm.formData.phone),callback:function ($$v) {_vm.$set(_vm.formData, "phone", $$v)},expression:"formData.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"个人邮箱","prop":"mail_address"}},[_c('el-input',{attrs:{"placeholder":"请输入个人邮箱"},model:{value:(_vm.formData.mail_address),callback:function ($$v) {_vm.$set(_vm.formData, "mail_address", $$v)},expression:"formData.mail_address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"办公地点","prop":"office_location"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择办公地点","clearable":""},model:{value:(_vm.formData.office_location),callback:function ($$v) {_vm.$set(_vm.formData, "office_location", $$v)},expression:"formData.office_location"}},_vm._l((_vm.officeLocationMap),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":Number(value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"目前所在院校","prop":"school"}},[_c('el-input',{attrs:{"placeholder":"请输入院校名称"},model:{value:(_vm.formData.school),callback:function ($$v) {_vm.$set(_vm.formData, "school", $$v)},expression:"formData.school"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"专业","prop":"major"}},[_c('el-input',{attrs:{"placeholder":"请输入专业"},model:{value:(_vm.formData.major),callback:function ($$v) {_vm.$set(_vm.formData, "major", $$v)},expression:"formData.major"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"学历","prop":"education_level"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择学历","clearable":""},model:{value:(_vm.formData.education_level),callback:function ($$v) {_vm.$set(_vm.formData, "education_level", $$v)},expression:"formData.education_level"}},_vm._l((_vm.educationLevelMap),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":Number(value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"当前学年段","prop":"grade_level"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择当前学年段","clearable":""},model:{value:(_vm.formData.grade_level),callback:function ($$v) {_vm.$set(_vm.formData, "grade_level", $$v)},expression:"formData.grade_level"}},_vm._l((_vm.gradeLevelMap),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":Number(value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"学生证照片","prop":"student_card_photos"}},[_c('el-upload',{ref:"studentCardUpload",staticClass:"upload-demo",attrs:{"auto-upload":false,"action":"","file-list":_vm.studentCardPhotoList,"list-type":"picture-card","accept":".jpg,.jpeg,.png","on-change":function (file, fileList) { return _vm.onChangeFile(file, fileList, 'student_card_photos'); },"on-remove":function (file, fileList) { return _vm.handleRemove(file, fileList, 'student_card_photos'); }}},[_c('i',{staticClass:"el-icon-plus"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"合同时间","prop":"contract_start_date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","value-format":"yyyy-MM-dd"},model:{value:(_vm.contractDateRange),callback:function ($$v) {_vm.contractDateRange=$$v},expression:"contractDateRange"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"备注","prop":"remark"}},[_c('el-input',{attrs:{"type":"textarea","rows":4,"placeholder":"请输入备注信息"},model:{value:(_vm.formData.remark),callback:function ($$v) {_vm.$set(_vm.formData, "remark", $$v)},expression:"formData.remark"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateInfoForm_vue__ = __webpack_require__(1867);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc5b9128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateInfoForm_vue__ = __webpack_require__(2128);
function injectStyle (ssrContext) {
  __webpack_require__(2126)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fc5b9128"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivateInfoForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc5b9128_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivateInfoForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2126:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("32a52742", content, true, {});

/***/ }),

/***/ 2127:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".id-card-upload-wrapper[data-v-fc5b9128]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:16px}.id-card-item[data-v-fc5b9128]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.id-card-uploader .el-upload[data-v-fc5b9128]{width:100px;height:100px;line-height:80px}.id-card-placeholder[data-v-fc5b9128]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100px;height:100px;color:#8c939d;border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.id-card-placeholder[data-v-fc5b9128]:hover{border-color:#409eff}.id-card-placeholder i[data-v-fc5b9128]{font-size:20px;margin-bottom:4px}.id-card-placeholder span[data-v-fc5b9128]{font-size:12px}.id-card-avatar[data-v-fc5b9128]{font-size:10px;width:100px;height:100px;display:block;-o-object-fit:cover;object-fit:cover;border:1px dashed #d9d9d9;border-radius:6px}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/components/PrivateInfoForm.vue"],"names":[],"mappings":"AACA,yCAAyC,oBAAoB,oBAAoB,aAAa,QAAQ,CACrG,AACD,+BAA+B,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,kBAAkB,CAC7P,AACD,8CAA8C,YAAY,aAAa,gBAAgB,CACtF,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,YAAY,aAAa,cAAc,0BAA0B,kBAAkB,eAAe,kBAAkB,eAAe,CAC5c,AACD,4CAA4C,oBAAoB,CAC/D,AACD,wCAAwC,eAAe,iBAAiB,CACvE,AACD,2CAA2C,cAAc,CACxD,AACD,iCAAiC,eAAe,YAAY,aAAa,cAAc,oBAAoB,iBAAiB,0BAA0B,iBAAiB,CACtK","file":"PrivateInfoForm.vue","sourcesContent":["\n.id-card-upload-wrapper[data-v-fc5b9128]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:16px\n}\n.id-card-item[data-v-fc5b9128]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.id-card-uploader .el-upload[data-v-fc5b9128]{width:100px;height:100px;line-height:80px\n}\n.id-card-placeholder[data-v-fc5b9128]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100px;height:100px;color:#8c939d;border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden\n}\n.id-card-placeholder[data-v-fc5b9128]:hover{border-color:#409EFF\n}\n.id-card-placeholder i[data-v-fc5b9128]{font-size:20px;margin-bottom:4px\n}\n.id-card-placeholder span[data-v-fc5b9128]{font-size:12px\n}\n.id-card-avatar[data-v-fc5b9128]{font-size:10px;width:100px;height:100px;display:block;-o-object-fit:cover;object-fit:cover;border:1px dashed #d9d9d9;border-radius:6px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"银行卡号","prop":"bank_card_number"}},[_c('el-input',{attrs:{"placeholder":"请输入银行卡号"},model:{value:(_vm.formData.bank_card_number),callback:function ($$v) {_vm.$set(_vm.formData, "bank_card_number", $$v)},expression:"formData.bank_card_number"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"银行名称","prop":"bank_name"}},[_c('el-input',{attrs:{"placeholder":"请输入银行名称,例如 中国工商银行"},model:{value:(_vm.formData.bank_name),callback:function ($$v) {_vm.$set(_vm.formData, "bank_name", $$v)},expression:"formData.bank_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开户支行","prop":"bank_branch_name"}},[_c('el-input',{attrs:{"placeholder":"请输入开户支行,例如 普陀祁连山南路支行"},model:{value:(_vm.formData.bank_branch_name),callback:function ($$v) {_vm.$set(_vm.formData, "bank_branch_name", $$v)},expression:"formData.bank_branch_name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"银行卡照片","prop":"bank_card_photo"}},[_c('el-upload',{ref:"bankCardUpload",staticClass:"upload-demo",attrs:{"auto-upload":false,"action":"","file-list":_vm.bankCardPhotoList,"list-type":"picture-card","accept":".jpg,.jpeg,.png","on-change":function (file, fileList) { return _vm.onChangeFile(file, fileList, 'bank_card_photo'); },"on-remove":function (file, fileList) { return _vm.handleRemove(file, fileList, 'bank_card_photo'); }}},[_c('i',{staticClass:"el-icon-plus"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证号","prop":"id_number"}},[_c('el-input',{attrs:{"placeholder":"请输入身份证号"},model:{value:(_vm.formData.id_number),callback:function ($$v) {_vm.$set(_vm.formData, "id_number", $$v)},expression:"formData.id_number"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"身份证照片(正反面)","prop":"id_card_photos"}},[_c('div',{staticClass:"id-card-upload-wrapper"},[_c('div',{staticClass:"id-card-item"},[_c('el-upload',{ref:"idCardFrontUpload",staticClass:"avatar-uploader id-card-uploader",attrs:{"auto-upload":false,"action":"","show-file-list":false,"accept":".jpg,.jpeg,.png","on-change":function (file, fileList) { return _vm.onChangeFile(file, fileList, 'id_card_front_photo'); },"on-remove":function () { return _vm.handleRemove(null, null, 'id_card_front_photo'); }}},[(_vm.formData.id_card_front_photo)?_c('img',{staticClass:"id-card-avatar",attrs:{"src":_vm.formData.id_card_front_photo}}):_c('div',{staticClass:"id-card-placeholder"},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('span',[_vm._v("正面")])])])],1),_vm._v(" "),_c('div',{staticClass:"id-card-item"},[_c('el-upload',{ref:"idCardBackUpload",staticClass:"avatar-uploader id-card-uploader",attrs:{"auto-upload":false,"action":"","show-file-list":false,"accept":".jpg,.jpeg,.png","on-change":function (file, fileList) { return _vm.onChangeFile(file, fileList, 'id_card_back_photo'); },"on-remove":function () { return _vm.handleRemove(null, null, 'id_card_back_photo'); }}},[(_vm.formData.id_card_back_photo)?_c('img',{staticClass:"id-card-avatar",attrs:{"src":_vm.formData.id_card_back_photo}}):_c('div',{staticClass:"id-card-placeholder"},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('span',[_vm._v("反面")])])])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userResourceLimitForm_vue__ = __webpack_require__(1868);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f422b8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userResourceLimitForm_vue__ = __webpack_require__(2137);
function injectStyle (ssrContext) {
  __webpack_require__(2130)
  __webpack_require__(2132)
  this["$style"] = __webpack_require__(2134)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f422b8b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userResourceLimitForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f422b8b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_userResourceLimitForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2130:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("b82fff80", content, true, {});

/***/ }),

/***/ 2131:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"userResourceLimitForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2132:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("473396e8", content, true, {});

/***/ }),

/***/ 2133:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"userResourceLimitForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2134:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("27250c94", content, true, {});

/***/ }),

/***/ 2135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"userResourceLimitForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export searchRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])())]
};

var formRules = {};

/***/ }),

/***/ 2137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',[_c('el-form-item',{attrs:{"label":"管理员"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"分配规则"}},[_c('el-select',{attrs:{"placeholder":"请选择"},model:{value:(_vm.rule),callback:function ($$v) {_vm.rule=$$v},expression:"rule"}},_vm._l((_vm.options.rules),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.rule === 2)?_c('el-form-item',{attrs:{"label":"选择省"}},[_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":_vm.onChangeProvince},model:{value:(_vm.provinceId),callback:function ($$v) {_vm.provinceId=$$v},expression:"provinceId"}},_vm._l((_vm.options.province),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),(_vm.rule === 2)?_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":_vm.onChangeCity},model:{value:(_vm.cityId),callback:function ($$v) {_vm.cityId=$$v},expression:"cityId"}},_vm._l((_vm.options.province),function(province){return (province.value === _vm.provinceId)?_c('span',_vm._l((province.children),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e()}),0):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.onAddResource}},[_vm._v("添加\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.rule === 2)?_c('el-form-item',{attrs:{"label":"选择区域"}},_vm._l((_vm.form.provinces),function(province,index){return _c('div',[_c('el-col',{attrs:{"span":20}},[_c('el-input',{attrs:{"type":"text","rows":2,"placeholder":"请输入内容","disabled":""},model:{value:(_vm.form.provinces[index].label),callback:function ($$v) {_vm.$set(_vm.form.provinces[index], "label", $$v)},expression:"form.provinces[index].label"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete"},on:{"click":function($event){return _vm.onDeleteResource(index)}}})],1)],1)}),0):_vm._e(),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")])],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2520:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audit_intern_rules_js__ = __webpack_require__(2122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseInfoForm_vue__ = __webpack_require__(2123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PrivateInfoForm_vue__ = __webpack_require__(2125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ResourceForm_vue__ = __webpack_require__(3206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__audit_intern_mixins_js__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_platform_user_province_components_userResourceLimitForm_vue__ = __webpack_require__(2129);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    userResourceLimitForm: __WEBPACK_IMPORTED_MODULE_7__views_platform_user_province_components_userResourceLimitForm_vue__["a" /* default */],
    BaseInfoForm: __WEBPACK_IMPORTED_MODULE_3__components_BaseInfoForm_vue__["a" /* default */],
    PrivateInfoForm: __WEBPACK_IMPORTED_MODULE_4__components_PrivateInfoForm_vue__["a" /* default */],
    ResourceForm: __WEBPACK_IMPORTED_MODULE_5__components_ResourceForm_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__audit_intern_mixins_js__["a" /* auditInternPermissionMixin */]],
  data: function data() {
    return {
      id: 0,
      baseFormRules: __WEBPACK_IMPORTED_MODULE_2__audit_intern_rules_js__["a" /* baseFormRules */],
      privateFormRules: __WEBPACK_IMPORTED_MODULE_2__audit_intern_rules_js__["b" /* privateFormRules */],
      baseLoading: false,
      privateLoading: false,
      baseForm: {
        name: '',
        realname: '',
        employment_type: 1,
        status: 1,
        phone: '',
        mail_address: '',
        office_location: null,
        school: '',
        major: '',
        education_level: null,
        grade_level: null,
        contract_start_date: '',
        contract_end_date: '',
        remark: '',
        student_card_photos: []
      },
      privateForm: {
        id_number: '',
        id_card_front_photo: '',
        id_card_back_photo: '',
        bank_name: '',
        bank_branch_name: '',
        bank_card_number: '',
        bank_card_photo: []
      },
      resourceForm: {
        assign_customer_ids: [],
        ui_role_ids: [],
        api_role_ids: []
      }
    };
  },

  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  computed: {
    activeTab: {
      get: function get() {
        return this.getActiveTab;
      },
      set: function set(val) {}
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map(['queryInternTableApi']), {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      // 重置路由查询参数，清除可能的file参数
      if (this.$route.query.file !== undefined) {
        this.$router.replace({
          path: this.$route.path,
          query: {}
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      if (this.allowViewEditBase() || this.allowViewEditResource()) {
        request.common('getInternBaseInfoApi', { id: id }).then(function (_ref) {
          var data = _ref.data;

          if (_this.allowViewEditBase()) filter.setLoop(_this.baseForm, data);

          if (_this.allowViewEditResource()) {
            _this.resourceForm.assign_customer_ids = data.assigned_customers.map(function (it) {
              return it.id;
            });
            _this.resourceForm.ui_role_ids = data.ui_roles.map(function (it) {
              return Number(it.id);
            });
            _this.resourceForm.api_role_ids = data.api_roles.map(function (it) {
              return Number(it.id);
            });
          }
        });
      }
      if (this.allowViewEditPrivate()) {
        request.common('getInternPrivateInfoApi', { id: id }).then(function (_ref2) {
          var data = _ref2.data;

          filter.setLoop(_this.privateForm, data);
        });
      }
    },
    onSubmitBase: function onSubmitBase() {
      var _this2 = this;

      this.$refs['baseForm'].validate(function (valid) {
        if (valid) {
          _this2.baseLoading = true;
          var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: _this2.id }, _this2.baseForm);
          params.education_level = params.education_level ? params.education_level : null;
          params.grade_level = params.grade_level ? params.grade_level : null;
          request.common('updateAuditInternBaseApi', params).then(function (res) {
            _this2.$message.success('基础资料保存成功');
          }).finally(function () {
            _this2.baseLoading = false;
          });
        } else {
          _this2.$message.error('基础资料填写不正确！');
        }
      });
    },
    onSubmitPrivate: function onSubmitPrivate() {
      var _this3 = this;

      this.$refs['privateForm'].validate(function (valid) {
        if (valid) {
          _this3.privateLoading = true;
          request.common('updateAuditInternPrivateApi', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: _this3.id }, _this3.privateForm)).then(function (res) {
            _this3.$message.success('隐私信息保存成功');
          }).finally(function () {
            _this3.privateLoading = false;
          });
        } else {
          _this3.$message.error('隐私信息填写不正确！');
        }
      });
    },
    onSubmitResource: function onSubmitResource() {
      var _this4 = this;

      this.$refs['resourceForm'].validate(function (valid) {
        if (valid) {
          request.common('updateAuditInternResourceApi', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: _this4.id }, _this4.resourceForm)).then(function (res) {
            _this4.$message.success('资源控制数据保存成功');
          });
        } else {
          _this4.$message.error('资源控制数据填写不正确！');
        }
      });
    },
    afterUpdateUserSource: function afterUpdateUserSource() {
      this.$message.success('用户资源分配成功');
    }
  })
});

/***/ }),

/***/ 2521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_RemoteSelect_vue__ = __webpack_require__(248);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RemoteSelect: __WEBPACK_IMPORTED_MODULE_1__core_components_RemoteSelect_vue__["a" /* default */] },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    formData: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['getCustomerTable', 'getCustomerDetail', 'forwardCoreApiRoleQueryApi', 'forwardCoreApiRoleDetailApi', 'forwardCoreUiRoleQueryApi', 'forwardCoreUiRoleDetailApi']))
});

/***/ }),

/***/ 3200:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3201);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c527781e", content, true, {});

/***/ }),

/***/ 3201:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".form-content-half .el-form-item__content{max-width:50%}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/AuditInternEditForm.vue"],"names":[],"mappings":"AACA,0CAA0C,aAAa,CACtD","file":"AuditInternEditForm.vue","sourcesContent":["\n.form-content-half .el-form-item__content{max-width:50%\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3202:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3203);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2c602a2a", content, true, {});

/***/ }),

/***/ 3203:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AuditInternEditForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3204:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3205);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("88abfb8a", content, true, {});

/***/ }),

/***/ 3205:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AuditInternEditForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceForm_vue__ = __webpack_require__(2521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_001b62d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceForm_vue__ = __webpack_require__(3209);
function injectStyle (ssrContext) {
  __webpack_require__(3207)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-001b62d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResourceForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_001b62d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResourceForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3207:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3208);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("48c84aa6", content, true, {});

/***/ }),

/***/ 3208:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".id-card-upload-wrapper[data-v-001b62d6]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:16px}.id-card-item[data-v-001b62d6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.id-card-uploader .el-upload[data-v-001b62d6]{width:100px;height:100px;line-height:80px}.id-card-placeholder[data-v-001b62d6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100px;height:100px;color:#8c939d;border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.id-card-placeholder[data-v-001b62d6]:hover{border-color:#409eff}.id-card-placeholder i[data-v-001b62d6]{font-size:20px;margin-bottom:4px}.id-card-placeholder span[data-v-001b62d6]{font-size:12px}.id-card-avatar[data-v-001b62d6]{font-size:10px;width:100px;height:100px;display:block;-o-object-fit:cover;object-fit:cover;border:1px dashed #d9d9d9;border-radius:6px}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/components/ResourceForm.vue"],"names":[],"mappings":"AACA,yCAAyC,oBAAoB,oBAAoB,aAAa,QAAQ,CACrG,AACD,+BAA+B,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,kBAAkB,CAC7P,AACD,8CAA8C,YAAY,aAAa,gBAAgB,CACtF,AACD,sCAAsC,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,YAAY,aAAa,cAAc,0BAA0B,kBAAkB,eAAe,kBAAkB,eAAe,CAC5c,AACD,4CAA4C,oBAAoB,CAC/D,AACD,wCAAwC,eAAe,iBAAiB,CACvE,AACD,2CAA2C,cAAc,CACxD,AACD,iCAAiC,eAAe,YAAY,aAAa,cAAc,oBAAoB,iBAAiB,0BAA0B,iBAAiB,CACtK","file":"ResourceForm.vue","sourcesContent":["\n.id-card-upload-wrapper[data-v-001b62d6]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:16px\n}\n.id-card-item[data-v-001b62d6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.id-card-uploader .el-upload[data-v-001b62d6]{width:100px;height:100px;line-height:80px\n}\n.id-card-placeholder[data-v-001b62d6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100px;height:100px;color:#8c939d;border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden\n}\n.id-card-placeholder[data-v-001b62d6]:hover{border-color:#409EFF\n}\n.id-card-placeholder i[data-v-001b62d6]{font-size:20px;margin-bottom:4px\n}\n.id-card-placeholder span[data-v-001b62d6]{font-size:12px\n}\n.id-card-avatar[data-v-001b62d6]{font-size:10px;width:100px;height:100px;display:block;-o-object-fit:cover;object-fit:cover;border:1px dashed #d9d9d9;border-radius:6px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":"客户资源"}},[_c('remote-select',{staticClass:"select-width",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请选择客户","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.formData.assign_customer_ids),callback:function ($$v) {_vm.$set(_vm.formData, "assign_customer_ids", $$v)},expression:"formData.assign_customer_ids"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"UI权限角色"}},[_c('remote-select',{staticClass:"select-width",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请选择UI权限角色","query-request":_vm.forwardCoreUiRoleQueryApi,"find-request":_vm.forwardCoreUiRoleDetailApi},model:{value:(_vm.formData.ui_role_ids),callback:function ($$v) {_vm.$set(_vm.formData, "ui_role_ids", $$v)},expression:"formData.ui_role_ids"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"API权限角色"}},[_c('remote-select',{staticClass:"select-width",attrs:{"clearable":"","multiple":"","id-key":"id","label-key":"name","value-key":"id","keyword-key":"name","placeholder":"请选择API权限角色","query-request":_vm.forwardCoreApiRoleQueryApi,"find-request":_vm.forwardCoreApiRoleDetailApi},model:{value:(_vm.formData.api_role_ids),callback:function ($$v) {_vm.$set(_vm.formData, "api_role_ids", $$v)},expression:"formData.api_role_ids"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/audit-intern/table"}},[_vm._v("实习生管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.allowViewEditBase())?_c('el-tab-pane',{attrs:{"label":"基础资料","name":"baseInfo"}},[_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"baseForm",staticClass:"form-content-half",attrs:{"model":_vm.baseForm,"rules":_vm.baseFormRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmitBase()}}},[_c('base-info-form',{ref:"baseInfoComponent",attrs:{"internId":String(_vm.id),"page-type":_vm.$route.meta.pageType},model:{value:(_vm.baseForm),callback:function ($$v) {_vm.baseForm=$$v},expression:"baseForm"}}),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"type":"primary","loading":_vm.baseLoading},on:{"click":function($event){return _vm.onSubmitBase()}}},[_vm._v("保存基础资料")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.allowViewEditPrivate())?_c('el-tab-pane',{attrs:{"label":"隐私信息","name":"privateInfo"}},[_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"privateForm",staticClass:"form-content-half",attrs:{"model":_vm.privateForm,"rules":_vm.privateFormRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmitPrivate()}}},[_c('private-info-form',{ref:"privateInfoComponent",attrs:{"internId":String(_vm.id)},model:{value:(_vm.privateForm),callback:function ($$v) {_vm.privateForm=$$v},expression:"privateForm"}}),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"type":"primary","loading":_vm.privateLoading},on:{"click":function($event){return _vm.onSubmitPrivate()}}},[_vm._v("保存隐私信息")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.allowViewEditResource())?_c('el-tab-pane',{attrs:{"label":"资源控制","name":"resourceInfo"}},[_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"resourceForm",staticClass:"form-content-half",attrs:{"model":_vm.resourceForm,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmitResource()}}},[_c('resource-form',{ref:"resourceComponent",model:{value:(_vm.resourceForm),callback:function ($$v) {_vm.resourceForm=$$v},expression:"resourceForm"}}),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-top":"20px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmitResource()}}},[_vm._v("保存资源控制")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.allowViewEditUserResource())?_c('el-tab-pane',{attrs:{"label":"分配用户资源","name":"userResourceInfo"}},[_c('layout-panel',{attrs:{"show-header":false}},[_c('userResourceLimitForm',{key:_vm.id,ref:"userResourceComponent",attrs:{"userid":_vm.id,"callbackAfterUpdate":_vm.afterUpdateUserSource}})],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audit-intern-form.9a18487568ded0300016.js